<tg-row class="summary-page-classified-listing-details-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Classified listing details</p>
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-classified-listing-details-section__header--right">
        <a routerLink="../{{ stepIds.listingDetails }}"
            routerLinkActive="active"
            class="h-link-no-visited">
            {{summarySectionLinkText}} classified listing details
        </a>
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-classified-listing-details-section__content">
        <span class="summary-page-classified-listing-details-section__content-label">Asking price:</span>
        {{ askingPrice }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-classified-listing-details-section__content">
        <span class="summary-page-classified-listing-details-section__content-label">Duration:</span>
        {{ duration }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-classified-listing-details-section__content">
        <span class="summary-page-classified-listing-details-section__content-label">Package option:</span>
        {{ packageOption }}
    </tg-col>
</tg-row>